import { render, staticRenderFns } from "./AddressFormSection.vue?vue&type=template&id=726455ce"
import script from "./AddressFormSection.vue?vue&type=script&lang=js"
export * from "./AddressFormSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports